import {AfterViewInit, Directive, OnDestroy, OnInit, Optional, Self} from '@angular/core';
import {ControlValueAccessor, NgControl} from "@angular/forms";
import {Subject} from "rxjs";
import {ComparableOperator} from "../../../models/form";

// export interface ClassWithComparatorsList<T> {
//   AllowedOperators: {[K: string]: (t: T, value: any) => boolean}
// }

@Directive()
export abstract class BaseAnswerTypeComponent<T> implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {
  protected _value: T;
  get value(): T {
    return this._value;
  }
  setValue(value: T) {
    this._value = value;
    this.onChange(value);
  }

  protected onChange: (_: T) => void;
  protected onTouched: () => void;
  protected isDisabled: boolean;
  protected onDestroy$ = new Subject<void>();

  readonly defaultValue;

  protected constructor(@Optional() @Self() public ngControl?: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(obj: any): void {
    this._value = obj;
  }

  ngOnInit() {
  }


  ngAfterViewInit() {
    this.ngControl.valueChanges.subscribe(value => {
      this._value = value;
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(void 0);
  }

  readonly abstract AllowedOperators: {[K in ComparableOperator]: (t: T, value: any) => boolean};

  compare(target: any, op: ComparableOperator, value: any): boolean {
    // console.log(`To compare ${target} with ${value} by ${op} in ${this.constructor.name}`);
    const opFunction = this.AllowedOperators[op];
    if (!opFunction) {
      console.error(`${this.constructor.name} doesn't support operator ${op}`)
      return false;
    }
    try {
      return opFunction(target, value);
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
